import React from "react";
import { Instagram, MessageCircle, MapPin } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { OctopusMascot } from "@/components/Mascot";
import { imgUrl, waLink } from "@/lib/api";

export default function Footer() {
  const { content } = useStore();
  const c = content?.contact || {};
  const year = new Date().getFullYear();

  return (
    <footer id="contato" className="relative bg-slate-900 text-slate-300 mt-24 overflow-hidden" data-testid="site-footer">
      <div className="absolute -top-1 right-8 opacity-90 hidden sm:block">
        <OctopusMascot size={72} className="rotate-180 translate-y-6" />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-3">
              {content?.logo_url ? (
                <img src={imgUrl(content.logo_url)} alt="Art3D" className="h-10 w-auto object-contain" />
              ) : (
                <>
                  <OctopusMascot size={38} />
                  <span className="text-2xl font-black text-white">Art<span className="text-gradient">3D</span></span>
                </>
              )}
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              {content?.tagline || "Produtos criativos feitos em impressão 3D."}
            </p>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">Contato</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={c.instagram_url || "https://instagram.com/art3dd_"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2.5 hover:text-pink-400 transition-colors"
                  data-testid="footer-instagram"
                >
                  <span className="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center"><Instagram size={15} /></span>
                  {c.instagram || "@art3dd_"}
                </a>
              </li>
              <li>
                <a
                  href={waLink(content, "Olá, Art3D!")}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2.5 hover:text-green-400 transition-colors"
                  data-testid="footer-whatsapp"
                >
                  <span className="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center"><MessageCircle size={15} /></span>
                  {c.whatsapp_display || "(84) 99467-7862"}
                </a>
              </li>
              <li className="flex items-center gap-2.5" data-testid="footer-location">
                <span className="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center"><MapPin size={15} /></span>
                {c.location || "Natal - RN"}
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">Links</h4>
            <ul className="space-y-2.5 text-sm">
              <li><a href="/" className="hover:text-pink-400 transition-colors">Início</a></li>
              <li><a href="/produtos" className="hover:text-pink-400 transition-colors">Produtos</a></li>
              <li><a href="/#categorias" className="hover:text-pink-400 transition-colors">Categorias</a></li>
              <li><a href="/#sobre" className="hover:text-pink-400 transition-colors">Sobre</a></li>
              <li><a href="/#contato" className="hover:text-pink-400 transition-colors">Contato</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">Feito em 3D</h4>
            <p className="text-sm text-slate-400 leading-relaxed">
              Cada peça é impressa com carinho, camada por camada, para deixar seu dia a dia mais divertido.
            </p>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500" data-testid="footer-copy">
            © {year} {content?.brand_name || "Art3D"}. Todos os direitos reservados.
          </p>
          <p className="text-xs text-slate-600">Feito com 💗 e impressão 3D em Natal - RN</p>
        </div>
      </div>
    </footer>
  );
}
